export enum Themes {
  light = "light",
  light_V2 = "light_V2",
  dark = "dark",
  dark_V2 = "dark_V2",
  dark_V3 = "dark_V3",
}
